export const GEOAPIFY_API_KEY = "fb9d52849cce4ad49b218de0e635adbd";
